import { createApiSlice } from "@common";
import {
  CRUD_PRODUCT_VARIANT,
  CRUD_PRODUCT_VARIANT_BY_ID,
  CRUD_PRODUCT_VARIANT_DETAIL_BY_ID
} from "@routes";

const apiConfig = [
  {
    name: "addProductVariant",
    method: "post",
    url: CRUD_PRODUCT_VARIANT,
    stateKey: "message",
  },
  {
    name: "getProductVariantById",
    method: "get",
    url: CRUD_PRODUCT_VARIANT_BY_ID,
    stateKey: "data",
  },
  {
    name: "updateProductVariant",
    method: "put",
    url: CRUD_PRODUCT_VARIANT,
    stateKey: "message",
  },
  {
    name: "deleteProductVariant",
    method: "delete",
    url: CRUD_PRODUCT_VARIANT,
    stateKey: "message",
  },
  {
    name: "getProductVariantDetailById",
    method: "get",
    url: CRUD_PRODUCT_VARIANT_DETAIL_BY_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
    resetProductVariant: (state) => {
      state.data = [];
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "productVariant",
  apiConfig,
  customReducers);
const productVariantSlice = slice;

export default productVariantSlice.reducer;

export const {
  addProductVariant,
  getProductVariantById,
  updateProductVariant,
  deleteProductVariant,
  getProductVariantDetailById
} = thunks;

export const {
  rowSelect,
  resetProductVariant,
} = actions;
